/**
 * AI service abstraction layer for workflow generation/modification.
 *
 * Interface:
 *   generateWorkflow(prompt, metadata) → Promise<WorkflowV2Schema>
 *   modifyWorkflow(prompt, currentSchema) → Promise<WorkflowV2Schema>
 *   explainStatus(currentSnapshot) → Promise<string>
 *   suggestNextActions(currentSnapshot) → Promise<string[]>
 *
 * Currently uses MockWorkflowAIService.
 * Will be replaced with BedrockWorkflowAIService when AWS Bedrock is wired.
 */

import { MockWorkflowAIService } from '../__dev__/mockWorkflowAI';

// Singleton instance — swap this when Bedrock is ready
let _instance = null;

/**
 * Get the AI service instance.
 */
export function getWorkflowAIService() {
  if (!_instance) {
    _instance = new MockWorkflowAIService();
  }
  return _instance;
}

/**
 * Set a custom AI service instance (for testing or Bedrock swap).
 */
export function setWorkflowAIService(service) {
  _instance = service;
}
